import type { PersonBooking } from './scheduleCommon';
import { updateLinkedAutoCompleteFieldValue } from './scheduleCommon';
import { isReservationNewPerson, ReservationExistingPerson, ReservationNewPerson, ReservationPerson } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/model';
import { modelState } from '../modelState';

export async function scheduleProfilePicker(
    peopleList: any[],
    initialPerson: PersonBooking | null,
    selectedPerson: modelState<ReservationPerson>,
    enabled: boolean) {

    await import('@syncfusion/ej2-base/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-calendars/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-dropdowns/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-navigations/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-splitbuttons/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-notifications/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-grids/styles/bootstrap5.3.css');

    await import('../loadSyncfusion');

    const { Grid } = await import('@syncfusion/ej2-grids');

    const { inputAutoComplete } = await import('./inputAutoComplete');

    let firstnameEle: any;
    let lastnameEle: any;
    let phoneEle: any;
    let emailEle: any;

    const data = {
        async resetValue() {

            this.personInfo = {
                firstName: '',
                lastName: '',
                phone: '',
                email: ''
            };

            await inputAutoComplete("input-firstname", null);
            await inputAutoComplete("input-lastname", null);
            await inputAutoComplete("input-phone", null);
            await inputAutoComplete("input-email", null);
        },
        personInfo: {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            personId: ''
        },
        clearPerson() {
            this.personInfo.firstName = '';
            this.personInfo.lastName = '';
            this.personInfo.phone = '';
            this.personInfo.email = '';
            this.personInfo.personId = '';

            (document.getElementById("input_input-firstname") as HTMLInputElement).disabled = false;
            (document.getElementById("input_input-lastname") as HTMLInputElement).disabled = false;
            (document.getElementById("input_input-phone") as HTMLInputElement).disabled = false;
            (document.getElementById("input_input-email") as HTMLInputElement).disabled = false;

            firstnameEle.value = '';
            lastnameEle.value = '';
            phoneEle.value = '';
            emailEle.value = '';

            selectedPerson.setValue(null);
        },
        async init() {
            if (initialPerson) {
                this.personInfo.firstName = initialPerson.firstName
                this.personInfo.lastName = initialPerson.lastName
                this.personInfo.phone = initialPerson.phone
                this.personInfo.email = initialPerson.email
                this.personInfo.personId = initialPerson.personId
            }

            const self = this;

            firstnameEle = await inputAutoComplete("input-firstname", self.personInfo.firstName, "First name", peopleList, "FirstName", function (e) {
                if (self.personInfo.personId) {
                    return;
                }

                self.personInfo.firstName = e.value;

                let nextPerson: ReservationNewPerson;
                const currentPerson = selectedPerson.value;

                if (isReservationNewPerson(currentPerson)) {
                    nextPerson = {
                        ...currentPerson,
                        FirstName: e.value
                    };
                } else {
                    nextPerson = {
                        [ReservationPerson]: true,
                        [ReservationNewPerson]: true,
                        FirstName: e.value,
                        LastName: null,
                        Email: null,
                        Phone: null
                    };
                }

                selectedPerson.setValue(nextPerson);
            });

            lastnameEle = await inputAutoComplete("input-lastname", self.personInfo.lastName, "Last name", peopleList, "LastName", function (e) {
                if (self.personInfo.personId) {
                    return;
                }

                self.personInfo.lastName = e.value;

                let nextPerson: ReservationNewPerson;
                const currentPerson = selectedPerson.value;

                if (isReservationNewPerson(currentPerson)) {
                    nextPerson = {
                        ...currentPerson,
                        LastName: e.value
                    };
                } else {
                    nextPerson = {
                        [ReservationPerson]: true,
                        [ReservationNewPerson]: true,
                        FirstName: null,
                        LastName: e.value,
                        Email: null,
                        Phone: null
                    };
                }

                selectedPerson.setValue(nextPerson);
            });

            phoneEle = await inputAutoComplete("input-phone", self.personInfo.phone, "Phone no.", peopleList, "PhoneNumber", function (e) {
                if (self.personInfo.personId) {
                    return;
                }

                self.personInfo.phone = e.value;

                let nextPerson: ReservationNewPerson;
                const currentPerson = selectedPerson.value;

                if (isReservationNewPerson(currentPerson)) {
                    nextPerson = {
                        ...currentPerson,
                        Phone: e.value
                    };
                } else {
                    nextPerson = {
                        [ReservationPerson]: true,
                        [ReservationNewPerson]: true,
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Phone: e.value
                    };
                }

                selectedPerson.setValue(nextPerson);
            });

            emailEle = await inputAutoComplete("input-email", self.personInfo.email, "Email", peopleList, "Email", function (e) {
                if (self.personInfo.personId) {
                    return;
                }

                self.personInfo.email = e.value;

                let nextPerson: ReservationNewPerson;
                const currentPerson = selectedPerson.value;

                if (isReservationNewPerson(currentPerson)) {
                    nextPerson = {
                        ...currentPerson,
                        Email: e.value
                    };
                } else {
                    nextPerson = {
                        [ReservationPerson]: true,
                        [ReservationNewPerson]: true,
                        FirstName: null,
                        LastName: null,
                        Email: e.value,
                        Phone: null
                    };
                }

                selectedPerson.setValue(nextPerson);
            });

            const containerEle = document.getElementById('container_person-search-grid');

            const personSearchGrid = new Grid({
                dataSource: [],
                columns: [
                    { field: 'FirstName', headerText: 'First Name', width: 120 },
                    { field: 'LastName', headerText: 'Last Name', width: 120 },
                    { field: 'PhoneNumber', headerText: 'Phone', width: 120 },
                    { field: 'Email', headerText: 'Email', width: 120 }
                ],
                height: 'auto',
                rowSelected: (args: any) => {
                    updateLinkedAutoCompleteFieldValue("input-firstname", args.data.FirstName);
                    updateLinkedAutoCompleteFieldValue("input-lastname", args.data.LastName);
                    updateLinkedAutoCompleteFieldValue("input-phone", args.data.PhoneNumber);
                    updateLinkedAutoCompleteFieldValue("input-email", args.data.Email);
                    self.personInfo.personId = args.data.PersonId

                    containerEle.style.display = "none"

                    const person: ReservationExistingPerson = {
                        [ReservationPerson]: true,
                        [ReservationExistingPerson]: true,
                        PersonId: args.data.PersonId,
                        ContactId: args.data.ContactId
                    };

                    selectedPerson.setValue(person);

                    (document.getElementById("input_input-firstname") as HTMLInputElement).disabled = true;
                    (document.getElementById("input_input-lastname") as HTMLInputElement).disabled = true;
                    (document.getElementById("input_input-phone") as HTMLInputElement).disabled = true;
                    (document.getElementById("input_input-email") as HTMLInputElement).disabled = true;
                },
                dataBound: () => {
                    if (personSearchGrid.currentViewData.length === 0) {
                        // hide when no record found.
                        containerEle.style.display = "none"
                        self.personInfo.personId = ''
                    }
                }
            });

            personSearchGrid.appendTo("#person-search-grid");

            containerEle.addEventListener('focusout', (event: FocusEvent) => {
                if (!(personSearchGrid.element.contains(event.target as Node) ||
                    firstnameEle.element.contains(event.target as Node) ||
                    lastnameEle.element.contains(event.target as Node) ||
                    phoneEle.element.contains(event.target as Node) ||
                    emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
                    containerEle.style.display = "none"
                }
            });
            document.addEventListener('click', (event: MouseEvent) => {
                if (!(personSearchGrid.element.contains(event.target as Node) ||
                    firstnameEle.element.contains(event.target as Node) ||
                    lastnameEle.element.contains(event.target as Node) ||
                    phoneEle.element.contains(event.target as Node) ||
                    emailEle.element.contains(event.target as Node)) && containerEle.style.display !== "none") {
                    containerEle.style.display = "none"
                }
            });

            if (!enabled) {
                (document.getElementById("input_input-firstname") as HTMLInputElement).disabled = true;
                (document.getElementById("input_input-lastname") as HTMLInputElement).disabled = true;
                (document.getElementById("input_input-phone") as HTMLInputElement).disabled = true;
                (document.getElementById("input_input-email") as HTMLInputElement).disabled = true;
            }
        },
    }

    return data;
}
